module.exports = __webpack_public_path__ + "img/Yamachan_tc.e82abf47.jpg";